module.exports = __webpack_public_path__ + "img/21_99.d2cea565.png";